<template>
    <div :id="'img-upload-'+id">
        <template v-if="allow_preview && url">
            <img :id="'img-'+id" :src="url" alt="" :class="img_class">
            <hr>
        </template>
        <div class="form-group form-inline">
            <label v-if="label != null" for="'input-'+id" :class="label_class">{{ trans(label) }}</label>
            <input :id="'input-'+id" type="file" :name="name" :accept="input_accept" :class="input_class"
                   @change="updateImg">
        </div>
    </div>
</template>

<style lang="scss">
    [id^='img-upload-'] > img {
        width: 100%;
        height: auto;
        object-fit: contain;
    }
</style>

<script>
    export default {
        props: ['name', 'img', 'accept', 'preview', 'l_class', 'i_class', 'ig_class', 'label'],
        data() {
            return {
                id: null,
                url: null,
                allow_preview: true,
                input_class: 'form-control col',
                label_class: '',
                img_class: 'border',
                input_accept: 'image/*'
            }
        },
        methods: {
            updateImg(e) {
                const file = e.target.files[0];
                this.url = URL.createObjectURL(file);
            }
        },
        mounted() {
            this.id = this._uid;
            this.url = this.img;
            this.allow_preview = (this.preview != null) ? this.preview : true;
            this.input_class = (this.i_class != null) ? this.i_class : this.input_class;
            this.label_class = (this.l_class != null) ? this.l_class : this.label_class;
            this.img_class = (this.ig_class != null) ? this.ig_class : this.img_class;
            this.input_accept = (this.accept != null) ? this.accept : this.input_accept;
        }
    }
</script>